
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/on-board",
      function () {
        return require("private-next-pages/on-board/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/on-board"])
      });
    }
  